const scriptOf = (html) => (html.match(/static\/js\/main\.[a-f0-9]+\.js/) || [])[0];

async function check() {
  const current = scriptOf(document.documentElement.innerHTML);
  if (!current) return;
  try {
    const res = await fetch(`/?v=${Date.now()}`, { cache: "no-store" });
    const latest = scriptOf(await res.text());
    if (latest && latest !== current && sessionStorage.getItem("rk_reloaded_for") !== latest) {
      sessionStorage.setItem("rk_reloaded_for", latest);
      window.location.reload();
    }
  } catch { /* offline */ }
}

export function startVersionCheck() {
  check();
  setInterval(check, 5 * 60 * 1000);
  document.addEventListener("visibilitychange", () => document.visibilityState === "visible" && check());
}
